<template>
  <div class="selector" v-if="selectedDress">

    <!--<div class="selected__image-wrapper">-->
      <!--<h3 class="pb-2 selector__title uppercase">Selected:</h3>-->
      <!--<img class="selected__image" :src="selectedDress.image" alt="" height="70" width="70">-->
    <!--</div>-->

    <div v-if="meshesOfDress(selectedDress).length">
      <h3 class="pt-4 selector__title uppercase">Components:</h3>
      <div class="mesh-selector__wrapper flex flex-wrap">
        <mesh-selector-button v-for="mesh in meshesOfDress(selectedDress)" :key="mesh.id" :mesh="mesh"></mesh-selector-button>
        <!--<button class="mesh-selector__button button button__outlined button__rounded"-->
                <!--:class="selectedMesh === mesh ? 'mesh-selector__button&#45;&#45;active' : '' "-->
                <!--v-for="mesh in meshesOfDress(selectedDress)"-->
                <!--:key="mesh.id"-->
                <!--@click="selectMesh(mesh)"> {{ mesh.name | cleanMeshName }}</button>-->
      </div>
    </div>

    <div v-if="accessoriesOfDress(selectedDress).length">
      <h3 class="pt-4 selector__title uppercase">Accessories:</h3>
      <div  class="mesh-selector__wrapper flex flex-wrap">
        <mesh-selector-button v-for="accessory in accessoriesOfDress(selectedDress)" :key="accessory.id" :mesh="accessory"></mesh-selector-button>
        <!--<button class="mesh-selector__button button button__outlined button__rounded"-->
                <!--:class="selectedMesh === accessory ? 'mesh-selector__button&#45;&#45;active' : '' "-->
                <!--v-for="accessory in accessoriesOfDress(selectedDress)"-->
                <!--:key="accessory.id"-->
                <!--@click="selectMesh(accessory)"> {{ accessory.name | cleanMeshName }}</button>-->
      </div>
    </div>

    <div v-if="selectedShoes && accessoriesOf(selectedShoes.inst).length">
      <h3 class="pt-4 selector__title uppercase">Shoes:</h3>
      <div  class="mesh-selector__wrapper flex flex-wrap">
        <mesh-selector-button v-for="shoesAccessory in accessoriesOf(selectedShoes.inst)" :key="shoesAccessory.id" :mesh="shoesAccessory"></mesh-selector-button>
        <!--<button class="mesh-selector__button button button__outlined button__rounded"-->
                <!--:class="selectedMesh === accessory ? 'mesh-selector__button&#45;&#45;active' : '' "-->
                <!--v-for="accessory in accessoriesOfDress(selectedDress)"-->
                <!--:key="accessory.id"-->
                <!--@click="selectMesh(accessory)"> {{ accessory.name | cleanMeshName }}</button>-->
      </div>
    </div>

  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';

  import MeshSelectorButton from '../partials/MeshSelectorButton';

  export default {
    name: "MeshSelector",
    components: {
      MeshSelectorButton,
    },
    computed: {
      ...mapGetters('clothes',[
        'selectedDress',
        'selectedMesh',
        'meshesOfDress',
        'accessoriesOfDress'
      ]),
      ...mapGetters('shoes',[
        'selectedShoes'
      ]),
      ...mapGetters('mannequin',[
        'accessoriesOf'
      ])
    },
    filters: {
      cleanMeshName: function(name) {
        if(!name) {
          return '';
        }

        // console.log(name.split('-').pop().replace('ACC_',''));

        let cleanedName = name.split('-').pop();
        cleanedName = cleanedName.replaceAll('ACC_','');
        cleanedName = cleanedName.replaceAll('_',' ');
        cleanedName = cleanedName.toUpperCase();
        // console.log(cleanedName);
        return cleanedName;

      }
    },
    methods: {
      ...mapActions('clothes',[
        'setSelectedMesh'
      ]),
      ...mapActions('camera',[
        'focusOnSelectedMesh'
      ]),
      ...mapActions([
        'render'
      ]),
      selectMesh(mesh) {
        this.focusOnSelectedMesh(mesh);
        this.setSelectedMesh(mesh);
      }
    },
  }
</script>

<style scoped>

  .mesh-selector__wrapper {
    /*border-bottom: 1px solid #CAC8C8;*/
    padding: 15px 0 0;
    flex-direction: column;
  }

  .mesh-selector__button {
    width: max-content;
    margin-bottom: 15px;
    margin-right: 15px;
    opacity: 0.6;
    height: 25px;
    line-height: 25px;
    padding: 0 10px;
    font-size: 12px;
    white-space: nowrap;
    background-color: rgba(255,255,255,0.4);
  }

  .mesh-selector__button--active {
    border-color: red;
    color: red;
    opacity: 1;
  }

  .selector__title {
    font-size: 12px;
  }

  .selected__image {
    height: 70px;
    width: 70px;
    border-radius: 70px;
    object-fit: cover;
  }

</style>